/* ============================================================
   HAYPER HYDE — HOME PAGE INTERACTIONS
   Vanilla JS, zero dipendenze. Idempotente (safe con Theme Editor).
   ============================================================ */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- utils ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ============================================================
     1. Reveal on scroll
     ============================================================ */
  function initReveal(root) {
    var items = $$('.hh-reveal', root);
    if (!items.length) return;

    if (REDUCED || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-in'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    items.forEach(function (el) { io.observe(el); });
  }

  /* ============================================================
     2. Patch swap (hero compositor)
     ============================================================ */
  function initSwap(root) {
    $$('[data-hh-swap]', root).forEach(function (swap) {
      if (swap.dataset.hhReady === '1') return;
      swap.dataset.hhReady = '1';

      var patchImg = $('[data-hh-swap-patch]', swap);
      var nameEl   = $('[data-hh-swap-name]', swap);
      var chips    = $$('[data-hh-chip]', swap);
      if (!patchImg || !chips.length) return;

      var timer = null;
      var autoplay = swap.dataset.autoplay === 'true' && !REDUCED;
      var idx = 0;

      function select(chip, fromUser) {
        chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c === chip)); });
        idx = chips.indexOf(chip);

        patchImg.setAttribute('data-state', 'out');
        window.setTimeout(function () {
          patchImg.src = chip.dataset.patchSrc || '';
          patchImg.alt = 'Patch ' + (chip.dataset.patchName || '') + ' applicata sul cappello Hayper Hyde';
          if (nameEl) nameEl.textContent = chip.dataset.patchName || '';
          patchImg.setAttribute('data-state', 'in');
        }, REDUCED ? 0 : 170);

        if (fromUser) stopAuto();
      }

      function stopAuto() {
        autoplay = false;
        if (timer) { window.clearInterval(timer); timer = null; }
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () { select(chip, true); });
      });

      // stato iniziale
      select(chips[0], false);

      if (autoplay) {
        timer = window.setInterval(function () {
          idx = (idx + 1) % chips.length;
          select(chips[idx], false);
        }, 2600);

        // stop all'interazione o quando fuori schermo
        ['pointerdown', 'keydown', 'wheel'].forEach(function (ev) {
          swap.addEventListener(ev, stopAuto, { once: true, passive: true });
        });

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (e) {
            if (!e[0].isIntersecting && timer) { window.clearInterval(timer); timer = null; }
          }, { threshold: 0 }).observe(swap);
        }
      }
    });
  }

  /* ============================================================
     3. Split reveal (una testa, due identità)
     ============================================================ */
  function initSplit(root) {
    $$('[data-hh-split]', root).forEach(function (split) {
      if (split.dataset.hhReady === '1') return;
      split.dataset.hhReady = '1';

      var top    = $('[data-hh-split-top]', split);
      var handle = $('[data-hh-split-handle]', split);
      var range  = $('[data-hh-split-range]', split);
      if (!top || !handle) return;

      function apply(pct) {
        pct = Math.max(2, Math.min(98, pct));
        top.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
        handle.style.left = pct + '%';
        if (range && Number(range.value) !== Math.round(pct)) range.value = Math.round(pct);
      }

      function fromEvent(e) {
        var rect = split.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
        apply((x / rect.width) * 100);
      }

      var dragging = false;
      split.addEventListener('pointerdown', function (e) {
        if (e.target === range) return;
        dragging = true;
        split.setPointerCapture && split.setPointerCapture(e.pointerId);
        fromEvent(e);
      });
      split.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
        split.addEventListener(ev, function () { dragging = false; });
      });

      if (range) {
        range.addEventListener('input', function () { apply(Number(range.value)); });
      }

      apply(50);
    });
  }

  /* ============================================================
     4. Contatore combinazioni
     ============================================================ */
  function initCounter(root) {
    $$('[data-hh-count]', root).forEach(function (el) {
      if (el.dataset.hhReady === '1') return;
      el.dataset.hhReady = '1';

      var target = parseInt(el.dataset.hhCount, 10) || 0;

      function run() {
        if (REDUCED) { el.textContent = target.toLocaleString('it-IT'); return; }
        var start = null, dur = 1400;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased).toLocaleString('it-IT');
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { run(); io.disconnect(); }
        }, { threshold: 0.4 });
        io.observe(el);
      } else { run(); }
    });
  }

  /* ============================================================
     5. Filtri universi + paginazione progressiva
     ============================================================ */
  function initFilters(root) {
    $$('[data-hh-filters]', root).forEach(function (wrap) {
      if (wrap.dataset.hhReady === '1') return;
      wrap.dataset.hhReady = '1';

      var buttons = $$('[data-hh-filter]', wrap);
      var grid    = document.getElementById(wrap.dataset.hhFilters);
      if (!grid) return;

      var cards    = $$('[data-hh-tags]', grid);
      var empty    = $('[data-hh-empty]', grid);
      var moreBtn  = document.querySelector('[data-hh-more="' + wrap.dataset.hhFilters + '"]');
      var pageSize = parseInt(grid.dataset.hhPage || '12', 10);
      var shown    = pageSize;
      var active   = '*';

      function matches(card) {
        return active === '*' || (' ' + card.dataset.hhTags + ' ').indexOf(' ' + active + ' ') > -1;
      }

      function render() {
        // Con un universo selezionato mostriamo TUTTE le patch di quell'universo.
        // La paginazione resta solo sulla vista "Tutte".
        var paginated = (active === '*');
        var count = 0;
        cards.forEach(function (card) {
          if (!matches(card)) { card.hidden = true; return; }
          count++;
          card.hidden = paginated && count > shown;
        });
        if (empty) empty.hidden = count > 0;
        if (moreBtn) moreBtn.hidden = !paginated || count <= shown;
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          active = btn.dataset.hhFilter;
          shown = pageSize;
          buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
          render();
        });
      });

      if (moreBtn) {
        moreBtn.addEventListener('click', function () {
          shown += pageSize;
          render();
        });
      }

      render();
    });
  }

  /* ============================================================
     6. FAQ accordion
     ============================================================ */
  function initFaq(root) {
    $$('[data-hh-faq]', root).forEach(function (faq) {
      if (faq.dataset.hhReady === '1') return;
      faq.dataset.hhReady = '1';

      $$('.hh-faq__q', faq).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          var open = btn.getAttribute('aria-expanded') === 'true';

          if (faq.dataset.single === 'true') {
            $$('.hh-faq__q', faq).forEach(function (b) {
              if (b === btn) return;
              b.setAttribute('aria-expanded', 'false');
              var p = document.getElementById(b.getAttribute('aria-controls'));
              if (p) p.setAttribute('data-open', 'false');
            });
          }

          btn.setAttribute('aria-expanded', String(!open));
          if (panel) panel.setAttribute('data-open', String(!open));
        });
      });
    });
  }

  /* ============================================================
     7. Sticky CTA mobile
     ============================================================ */
  function initSticky(root) {
    var bar = $('[data-hh-sticky]', root || document);
    if (!bar || bar.dataset.hhReady === '1') return;
    bar.dataset.hhReady = '1';

    var trigger = document.getElementById(bar.dataset.hhSticky || '');
    if (!trigger || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-on', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(trigger);
  }

  /* ============================================================
     Boot
     ============================================================ */
  function boot(root) {
    initReveal(root);
    initSwap(root);
    initSplit(root);
    initCounter(root);
    initFilters(root);
    initFaq(root);
    initSticky(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Shopify Theme Editor
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();